module.exports = __webpack_public_path__ + "img/member1.3ace18ee.png";